import brandLogo from "../../assets/images/tnp-logo-neon.png";
import { siteTexts } from "../i18n/siteTexts";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-brand">
        <img src={brandLogo} alt="TNP" className="footer-logo" />
        <p>{siteTexts.footer.description}</p>
      </div>
      <div className="footer-links">
        <a
          href="https://instagram.com/todosnopadel"
          className="footer-instagram"
          target="_blank"
          rel="noreferrer"
          aria-label={siteTexts.footer.instagramAriaLabel}
        >
          <span className="footer-instagram-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <path d="M7.75 2h8.5A5.75 5.75 0 0 1 22 7.75v8.5A5.75 5.75 0 0 1 16.25 22h-8.5A5.75 5.75 0 0 1 2 16.25v-8.5A5.75 5.75 0 0 1 7.75 2Zm0 1.5A4.25 4.25 0 0 0 3.5 7.75v8.5a4.25 4.25 0 0 0 4.25 4.25h8.5a4.25 4.25 0 0 0 4.25-4.25v-8.5a4.25 4.25 0 0 0-4.25-4.25h-8.5Zm8.9 1.9a1.05 1.05 0 1 1 0 2.1 1.05 1.05 0 0 1 0-2.1ZM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 1.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z" />
            </svg>
          </span>
          <span className="footer-instagram-handle">
            {siteTexts.footer.instagramHandle}
          </span>
        </a>
        <div className="footer-legal-inline">
          <a href="#/politica-privacidade">{siteTexts.footer.privacyPolicy}</a>
          <a href="#/termos-de-uso">{siteTexts.footer.termsOfUse}</a>
        </div>
      </div>
    </footer>
  );
}
